import React from "react";
import { Modal } from "react-bootstrap";
import Back from "assets/images/svg/back_blue.svg";
import Info from "assets/images/svg/info_dark.svg";
import { Controller } from "react-hook-form";
import FlagComponent from "components/flag/flag.component";
import { Button, Form, InputField } from "components/form";
import { numbersOnly } from "helpers/patterns";
import { validatePhone } from "helpers/data";
import { useTranslation } from "react-i18next";
import { PhoneNumber } from "awesome-phonenumber";
import { client } from "helpers/client";
import { PreregisterDto, usePreregisterData } from "pages/registration/registration.service";
import { toast } from "react-toastify";
import { useStatus } from "hooks/use-status";

interface Props {
  show: boolean;
  onHide: () => void;
  onChangeNumber: (preregisterData: PreregisterDto) => void;
  countryCode?: string;
}

const ChangeNumberComponent = ({ show, onHide, onChangeNumber, countryCode = "20" }: Props) => {
  const { t } = useTranslation();
  const { preregisterData } = usePreregisterData();
  const { isLoading, load, done, stop } = useStatus();

  async function handleNumberChange(data: any) {
    load();
    const mobile = (validatePhone(data.phoneNumber, data.countryCode) as PhoneNumber).getNumber();
    if (!preregisterData) return toast.error("Invalid Operation");

    const changeNumberDto = { mobileId: preregisterData.mobileId, newMobile: mobile, newMobileCountryCode: data.countryCode };
    const { response, error } = await client<PreregisterDto>("/auth/changeMobile", { data: changeNumberDto });
    if (error) return stop();
    if (response) {
      done();
      onChangeNumber(response);
    }
  }

  return (
    <div>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={onHide}
        className="all-modal changeNumber"
      >
        <Modal.Body>
          <Form onSubmit={handleNumberChange}>
            {({ control, watch }) => {
              return (
                <>
                  <div className="header">
                    <img src={Back} alt="back" onClick={onHide} />
                    <h1>{t("signup:changeNumber")}</h1>
                  </div>
                  <div className="row">
                    <div className="col-md-2">
                      <Controller
                        rules={{ required: "required" }}
                        render={({ field }) => <FlagComponent onChange={field.onChange} value={field.value ?? countryCode} />}
                        defaultValue={countryCode}
                        name="countryCode"
                        control={control}
                      />
                    </div>
                    <div className="col-md-10">
                      <InputField
                        id="phoneNumber"
                        label={t("signup:mobileNumber")}
                        rules={{
                          required: "errors:required",
                          pattern: {
                            value: numbersOnly,
                            message: "errors:onlyNumber"
                          },
                          validate: () => !!validatePhone(watch("phoneNumber"), watch("countryCode")) || "errors:invalidFormat"
                        }}
                      />
                    </div>

                    <div className="col-12">
                      <div className="info">
                        <img src={Info} alt="info" />
                        <p>{t("signup:important")}</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <Button isLoading={isLoading} className="btn-blue">
                      {t("signup:change")}
                    </Button>
                  </div>
                </>
              );
            }}
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ChangeNumberComponent;
